<template>
    <div class="card-footer py-2 px-3" v-if="showButtons">
        <responsive>
            <div class="btn-toolbar d-flex flex-nowrap">
                <div class="pr-3 mr-3 border-right" v-if="showChooseSelectedButton">
                    <button class="btn btn-primary" @click.prevent="chooseSelected()" :disabled="checked.length == 0 && !selected">
                        <i class="fa fa-check"></i> {{ $t('[[[Wybierz zaznaczone]]]') }}
                    </button>
                </div>

                <div class="btn-group mr-3" v-if="showCreateFolderButton">
                    <button class="btn btn-secondary" @click.prevent="$refs.createFolderModal.show()">
                        <i class="fa fa-folder"></i> {{ $t('[[[Utwórz katalog]]]') }}
                    </button>
                </div>

                <div class="btn-group mr-3" v-if="showRenameButton || showMoveButton || showDeleteButton">
                    <button class="btn btn-secondary" v-if="showRenameButton" @click.prevent="showRenameModal()">
                        <i class="fa fa-pencil-alt"></i>
                        {{ $t('[[[Zmień nazwę]]]') }}
                    </button>
                    <button class="btn btn-secondary" v-if="showMoveButton" @click.prevent="$refs.moveCheckedModal.show()">
                        <i class="fa fa-arrow-alt-circle-down"></i>
                        {{ $t('[[[Przenieś wybrane]]]') }}
                    </button>
                    <button class="btn btn-danger" v-if="showDeleteButton" @click.prevent="$refs.deleteSelectedModal.show()">
                        <i class="fa fa-times"></i> {{ $t('[[[Usuń wybrane]]]') }}
                    </button>
                </div>

                <div class="btn-group mr-3" v-if="showDownloadButton || showCropperButton">
                    <a :href="selected.url | baseurl" target="__blank" class="btn btn-secondary" v-if="showDownloadButton">
                        <i class="fa fa-download"></i>
                        {{ $t('[[[Pobierz plik]]]') }}
                    </a>
                    <button class="btn btn-success" v-if="showCropperButton" @click.prevent="editImage(true)">
                        <i class="fa fa-paint-brush"></i>
                        {{ $t('[[[Edytuj obraz]]]') }}
                    </button>
                </div>

                <div class="btn-toolbar" v-if="showCropperToolbar">
                    <button class="btn btn-secondary" @click.prevent="cropImage()">
                        <i class="fa fa-crop"></i>
                        {{ $t('[[[Wytnij]]]') }}
                    </button>
                    <button class="btn btn-secondary" @click.prevent="$refs.resizeImageModal.show()">
                        <i class="fa fa-expand-arrows-alt"></i>
                        {{ $t('[[[Zmień rozmiar]]]') }}
                    </button>
                    <button class="btn btn-light" @click.prevent="editImage(false)">
                        <i class="fa fa-ban"></i>
                        {{ $t('[[[Anuluj]]]') }}
                    </button>
                </div>
            </div>
        </responsive>

        <b-modal ref="createFolderModal" :title="$t('[[[Utwórz katalog]]]')" hide-footer>
            <form @submit.prevent="createFolder" @keydown="modals.folder.create.form.$errors.clear($event.target.name)">
                <b-form-group :label="$t('[[[Nazwa katalogu]]]')" :feedback="modals.folder.create.form.$errors.first('folderName')" :state="modals.folder.create.form.$errors.state('folderName')" horizontal>
                    <b-form-input v-model="modals.folder.create.form.folderName" type="text" name="folderName"></b-form-input>
                </b-form-group>
                <div class="text-right">
                    <button type="submit" class="btn btn-primary" :disabled="modals.folder.create.form.disabled()">
                        <i class="fas fa-spinner fa-spin" v-if="modals.folder.create.form.disabled()"></i>
                        <i class="fas fa-check" v-if="!modals.folder.create.form.disabled()"></i>
                        <span class="text">{{ $t('[[[Zapisz]]]') }}</span>
                    </button>
                    <button class="btn btn-default" @click.prevent.prevent="$refs.createFolderModal.hide()" :disabled="modals.folder.create.form.disabled()">
                        <i class="fa fa-ban"></i>
                        {{ $t('[[[Anuluj]]]') }}
                    </button>
                </div>
            </form>
        </b-modal>

        <b-modal ref="renameFileModal" :title="$t('[[[Zmień nazwę pliku]]]')" hide-footer>
            <form @submit.prevent="renameFile" @keydown="modals.file.rename.form.$errors.clear($event.target.name)">
                <b-form-group :label="$t('[[[Nazwa pliku]]]')" :feedback="modals.file.rename.form.$errors.first('fileName')" :state="modals.file.rename.form.$errors.state('fileName')" horizontal>
                    <b-form-input v-model="modals.file.rename.form.fileName" type="text" name="fileName"></b-form-input>
                </b-form-group>
                <div class="text-right">
                    <button type="submit" class="btn btn-primary" :disabled="modals.file.rename.form.disabled()">
                        <i class="fas fa-spinner fa-spin" v-if="modals.file.rename.form.disabled()"></i>
                        <i class="fas fa-check" v-if="!modals.file.rename.form.disabled()"></i>
                        {{ $t('[[[Zapisz]]]') }}
                    </button>
                    <button class="btn btn-default" @click.prevent.prevent="$refs.renameFileModal.hide()" :disabled="modals.file.rename.form.disabled()">
                        <i class="fa fa-ban"></i>
                        {{ $t('[[[Anuluj]]]') }}
                    </button>
                </div>
            </form>
        </b-modal>

        <b-modal ref="renameFolderModal" :title="$t('[[[Zmień nazwę katalogu]]]')" hide-footer>
            <form @submit.prevent="renameFolder" @keydown="modals.folder.rename.form.$errors.clear($event.target.name)">
                <b-form-group :label="$t('[[[Nazwa katalogu]]]')" :feedback="modals.folder.rename.form.$errors.first('folderName')" :state="modals.folder.rename.form.$errors.state('folderName')" horizontal>
                    <b-form-input v-model="modals.folder.rename.form.folderName" type="text" name="folderName"></b-form-input>
                </b-form-group>
                <div class="text-right">
                    <button type="submit" class="btn btn-primary" :disabled="modals.folder.rename.form.disabled()">
                        <i class="fas fa-spinner fa-spin" v-if="modals.folder.rename.form.disabled()"></i>
                        <i class="fas fa-check" v-if="!modals.folder.rename.form.disabled()"></i>
                        {{ $t('[[[Zapisz]]]') }}
                    </button>
                    <button class="btn btn-default" @click.prevent.prevent="$refs.renameFolderModal.hide()" :disabled="modals.folder.rename.form.disabled()">
                        <i class="fa fa-ban"></i>
                        {{ $t('[[[Anuluj]]]') }}
                    </button>
                </div>
            </form>
        </b-modal>

        <b-modal ref="deleteSelectedModal" :title="$t('[[[Usunięcie wybranych elementów]]]')" hide-footer>
            <p>{{ $t('[[[Na pewno usunąć wybrane elementy?]]]') }}</p>
            <div class="text-right">
                <button type="submit" class="btn btn-danger" @click.prevent="deleteSelected()" :disabled="busy">
                    <i class="fas fa-spinner fa-spin" v-if="busy"></i>
                    <i class="fas fa-check" v-if="!busy"></i>
                    {{ $t('[[[Usuń]]]') }}
                </button>
                <button class="btn btn-default" @click.prevent="$refs.deleteSelectedModal.hide()" :disabled="busy">
                    <i class="fa fa-ban"></i>
                    {{ $t('[[[Anuluj]]]') }}
                </button>
            </div>
        </b-modal>

        <b-modal ref="moveCheckedModal" :title="$t('[[[Przeniesienie wybranych elementów]]]')" hide-footer>
            <p>{{ $t('[[[Na pewno przenieść wybrane elementy do bieżącego katalogu?]]]') }}</p>
            <div class="text-right">
                <button type="submit" class="btn btn-primary" @click.prevent="moveChecked()" :disabled="busy">
                    <i class="fas fa-spinner fa-spin" v-if="busy"></i>
                    <i class="fas fa-check" v-if="!busy"></i>
                    {{ $t('[[[Przenieś]]]') }}
                </button>
                <button class="btn btn-default" @click.prevent="$refs.moveCheckedModal.hide()" :disabled="busy">
                    <i class="fa fa-ban"></i>
                    {{ $t('[[[Anuluj]]]') }}
                </button>
            </div>
        </b-modal>

        <b-modal ref="resizeImageModal" :title="$t('[[[Zmiana rozmiaru obrazu]]]')" hide-footer>
            <form @submit.prevent="resizeImage" @keydown="modals.folder.rename.form.$errors.clear($event.target.name)">
                <b-form-group :label="$t('[[[Szerokość]]]')" :feedback="modals.file.resize.form.$errors.first('width')" :state="modals.file.resize.form.$errors.state('width')" horizontal>
                    <b-input-group append="px">
                        <b-form-input v-model="modals.file.resize.form.width" type="number" name="width"></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-form-group :label="$t('[[[Wysokość]]]')" :feedback="modals.file.resize.form.$errors.first('height')" :state="modals.file.resize.form.$errors.state('height')" horizontal>
                    <b-input-group append="px">
                        <b-form-input v-model="modals.file.resize.form.height" type="number" name="height"></b-form-input>
                    </b-input-group>
                </b-form-group>
                <div class="text-right">
                    <button type="submit" class="btn btn-primary" :disabled="modals.file.resize.form.disabled()">
                        <i class="fas fa-spinner fa-spin" v-if="modals.file.resize.form.disabled()"></i>
                        <i class="fas fa-check" v-if="!modals.file.resize.form.disabled()"></i>
                        {{ $t('[[[Wykonaj]]]') }}
                    </button>
                    <button class="btn btn-default" @click.prevent.prevent="$refs.resizeImageModal.hide()" :disabled="modals.file.resize.form.disabled()">
                        <i class="fa fa-ban"></i>
                        {{ $t('[[[Anuluj]]]') }}
                    </button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import filter from 'lodash/filter';
import Form from '@/helpers/Form';
import StorageService from '@/services/core/StorageService';

export default {
    name: 'filemanager-tabs',
    props: {
        'modal': {
            type: Boolean,
            required: true
        },
        'cropper': {
            type: Boolean,
            required: true
        },
        'scope': {
            type: String,
            required: true,
            default: 'public'
        },
        'folder': {
            required: true
        },
        'selected': {
            required: true
        },
        'checked': {
            type: Array,
            required: true
        }
    },
    data: function()
    {
        return {
            modals: {
                folder: {
                    create: {
                        form: Form.create({
                            folderName: ''
                        })
                    },
                    rename: {
                        form: Form.create({
                            folderName: ''
                        })
                    }
                },
                file: {
                    rename: {
                        form: Form.create({
                            fileName: ''
                        })
                    },
                    crop: {
                        form: Form.create({
                            width: 0,
                            height: 0,
                            x: 0,
                            y: 0
                        })
                    },
                    resize: {
                        form: Form.create({
                            width: 100,
                            height: 100
                        })
                    }
                }
            },
            busy: false
        };
    },
    mounted()
    {
        this.$events.$on('filemanager-crop-changed', this.cropChanged);
    },
    destroyed()
    {
        this.$events.$off('filemanager-crop-changed');
    },
    computed: {
        showButtons()
        {
            return this.showCropperToolbar ||
                   this.showChooseSelectedButton ||
                   this.showCreateFolderButton ||
                   this.showRenameButton ||
                   this.showMoveButton ||
                   this.showDeleteButton ||
                   this.showDownloadButton ||
                   this.showCropperButton;
        },
        showCropperToolbar()
        {
            return this.cropper;
        },
        showChooseSelectedButton()
        {
            return !this.cropper && this.modal;
        },
        showCreateFolderButton()
        {
            return !this.cropper && this.scope !== 'selected';
        },
        showRenameButton()
        {
            return !this.cropper && this.selected;
        },
        showMoveButton()
        {
            return !this.cropper && this.checked.length > 0;
        },
        showDeleteButton()
        {
            return !this.cropper && (this.selected || this.checked.length);
        },
        showDownloadButton()
        {
            return !this.cropper && this.selected && this.selected.resourceType === 'file';
        },
        showCropperButton()
        {
            return !this.cropper && this.selected && this.selected.resourceType === 'file' && this.selected.isImage;
        }
    },
    methods: {
        chooseSelected()
        {
            let files = this.checked.length ? this.checked : this.selected ? [this.selected] : [];

            this.$events.$emit('filemanager-callback-value', filter(files, p => p.resourceType === 'file'));
        },
        async createFolder()
        {
            let form = this.modals.folder.create.form;

            try
            {
                form.disable();

                await StorageService.createFolder({
                    scope: this.scope,
                    parentId: this.folder,
                    folderName: form.folderName
                });

                form.enable();
                this.$alert.success(this.$t('[[[Katalog został utworzony.]]]'));
                this.$refs.createFolderModal.hide();
                form.folderName = '';
                this.$emit('reload');
            }
            catch (ex)
            {
                form.enable();

                if (ex.code === 400)
                {
                    this.$alert.warning(ex.message);
                }
                if (ex.code === 422)
                {
                    form.$errors.record(ex.data.errors);
                }

                this.$log.debug(ex);
            }
        },
        showRenameModal()
        {
            if (this.selected)
            {
                if (this.selected.resourceType === 'file')
                {
                    this.modals.file.rename.form.fileName = this.selected.name;
                    this.$refs.renameFileModal.show();
                }
                else
                {
                    this.modals.folder.rename.form.folderName = this.selected.name;
                    this.$refs.renameFolderModal.show();
                }
            }
        },
        async renameFolder()
        {
            let form = this.modals.folder.rename.form;

            try
            {
                form.disable();

                await StorageService.renameFolder(this.selected.id, form.folderName);

                form.enable();
                this.$alert.success(this.$t('[[[Nazwa katalogu została zmieniona.]]]'));
                this.$refs.renameFolderModal.hide();
                this.$emit('reload');
            }
            catch (ex)
            {
                form.enable();

                if (ex.code === 400)
                {
                    this.$alert.warning(ex.message);
                }
                if (ex.code === 422)
                {
                    form.$errors.record(ex.data.errors);
                }

                this.$log.debug(ex);
            }
        },
        async renameFile()
        {
            let form = this.modals.file.rename.form;

            try
            {
                form.disable();

                await StorageService.renameFile(this.selected.id, form.fileName);

                form.enable();
                this.$alert.success(this.$t('[[[Nazwa pliku została zmieniona.]]]'));
                this.$refs.renameFileModal.hide();
                this.$emit('reload');
            }
            catch (ex)
            {
                form.enable();

                if (ex.code === 400)
                {
                    this.$alert.warning(ex.message);
                }
                if (ex.code === 422)
                {
                    form.$errors.record(ex.data.errors);
                }

                this.$log.debug(ex);
            }
        },
        async deleteSelected()
        {
            let items = this.checked.slice();

            if (items.length === 0 && this.selected)
            {
                items.push(this.selected);
            }

            if (items.length > 0)
            {
                try
                {
                    this.busy = true;

                    await StorageService.deleteResources(items);

                    this.busy = false;
                    this.$alert.success(this.$t('[[[Wybrane elementy zostały usunięte.]]]'));
                    this.$refs.deleteSelectedModal.hide();
                    this.$emit('deleted');
                }
                catch (ex)
                {
                    this.busy = false;

                    if (ex.code === 400)
                    {
                        this.$alert.warning(ex.message);
                    }

                    this.$log.debug(ex);
                }
            }
        },
        async moveChecked()
        {
            let items = this.checked.slice();

            if (items.length > 0)
            {
                try
                {
                    this.busy = true;

                    var result = await StorageService.moveResources(this.folder, items);

                    if (result.data.folders.length > 0 || result.data.files.length > 0)
                    {
                        this.$alert.warning(this.$t('[[[Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.]]]'));
                    }
                    else
                    {
                        this.$alert.success(this.$t('[[[Wybrane elementy zostały przeniesione.]]]'));
                    }

                    this.busy = false;
                    this.$refs.moveCheckedModal.hide();
                    this.$emit('moved', {
                        folders: result.data.folders,
                        files: result.data.files
                    });
                }
                catch (ex)
                {
                    this.busy = false;

                    if (ex.code === 400)
                    {
                        this.$alert.warning(ex.message);
                    }

                    this.$log.debug(ex);
                }
            }
        },
        editImage(enabled)
        {
            this.$events.$emit('filemanager-button-cropper', enabled);
        },
        cropChanged(params)
        {
            let form = this.modals.file.crop.form;

            form.width = params.width;
            form.height = params.height;
            form.x = params.x;
            form.y = params.y;
        },
        async cropImage()
        {
            let form = this.modals.file.crop.form;

            try
            {
                this.busy = true;

                await StorageService.cropImage(this.selected.id, form.data());

                this.busy = false;
                this.$alert.success(this.$t('[[[Obraz został wycięty.]]]'));
                this.editImage(false);
                this.$emit('reload');
            }
            catch (ex)
            {
                this.busy = false;

                if (ex.code === 400)
                {
                    this.$alert.warning(ex.message);
                }

                this.$log.debug(ex);
            }
        },
        async resizeImage()
        {
            let form = this.modals.file.resize.form;

            try
            {
                form.disable();

                await StorageService.resizeImage(this.selected.id, form.data());

                form.enable();
                this.$alert.success(this.$t('[[[Rozmiar zdjęcia został zmieniony.]]]'));
                this.$refs.resizeImageModal.hide();
                this.editImage(false);
                this.$emit('reload');
            }
            catch (ex)
            {
                form.enable();

                if (ex.code === 400)
                {
                    this.$alert.warning(ex.message);
                }
                if (ex.code === 422)
                {
                    form.$errors.record(ex.data.errors);
                }

                this.$log.debug(ex);
            }
        }
    }
};
</script>

<style scoped>

</style>
